import script from "./ProjectMembersList.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectMembersList.vue?vue&type=script&setup=true&lang=js"

import "./ProjectMembersList.vue?vue&type=style&index=0&id=a96adcca&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a96adcca"]])

export default __exports__